<template>
  <div class="card-body pt-0 edge-to-edge" v-if="$gate.isAdmin()">
    <div id="tabel_facturi_primite_wrapper">
      <div class="table-responsive">
        <table class="table table-bordered table-striped nowrap" role="grid" id="tabel_facturi_primite">
          <thead>
            <tr class="text-uppercase fw-bold">
              <th class="text-center" style="width:32px">
                <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="selectAllVisibleChecked"
                    @change="onToggleSelectAllVisible($event)"
                  />
                </div>
              </th>
              <th></th>
              <th>Data</th>
              <th>Data eF</th>
              <th>Nr. doc.</th>
              <th>Furnizor</th>
              <th>Valoare</th>
              <th>TVA</th>
              <th>Total</th>
              <th>Stare</th>
              <th>Scadenta</th>
              <th>TVA-I</th>
              <th>Agent</th>
              <th>Reg.Jurn</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="factura in facturi" :key="`fp_${factura.id}`">
              <tr :class="`row-fp-${factura.id}`">
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                    <input
                      class="form-check-input row-select"
                      type="checkbox"
                      :checked="isSelected(factura.id)"
                      @change="onToggleSelect(factura.id, $event)"
                    />
                  </div>
                </td>
                <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                  <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                </td>
                <td>{{ formatDate(factura.data_doc) || '/' }}</td>
                <td>{{ $filters.formatDate(factura.afp_data_creare) || '/' }}</td>
                <td :data-order="Number(factura.nr_doc) || 0">
                    {{ factura.serie_doc }}{{ factura.nr_doc }}
                </td>
                <td>
                    {{ factura.id?.toString().startsWith('anaf_') 
                        ? (factura.f_denumire?.match(/cif_emitent=(\d+)/)?.[1] || '-') 
                        : (factura.f_denumire || '/') 
                    }}
                </td>
                <td class="text-end">{{ formatMoney(factura.intrari_date_valoare) }}</td>
                <td class="text-end">{{ formatMoney(factura.intrari_date_tva) }}</td>
                <td class="text-end">{{ formatMoney(factura.intrari_date_total) }}</td>
                <td>
                  <div class="progress h-30px">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-6 py-2"
                      :class="{
                        'bg-danger': factura.stare === 0 || !factura.stare,
                        'bg-warning': factura.stare === 1,
                        'bg-success': factura.stare === 2
                      }"
                      role="progressbar"
                      :style="{
                        width: factura.stare === 0 || !factura.stare ? '100%' :
                                factura.stare === 1 ? '75%' :
                                '100%'
                      }"
                      :aria-valuenow="factura.stare === 0 || !factura.stare ? 100 :
                                      factura.stare === 1 ? 75 : 100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ factura.stare === 0 || !factura.stare ? 'Restant' :
                          factura.stare === 1 ? 'Parțial' :
                          'Achitat' }}
                    </div>
                  </div>
                </td>
                <td>{{ formatDate(factura.data_scadenta) || '/' }}</td>
                <td class="text-center">
                  <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                    <input class="form-check-input" type="checkbox" :checked="!!factura.tva_incasare" disabled />
                  </div>
                </td>
                <td>{{ factura.agent || '-' }}</td>
                <td class="text-center">
                  <span v-if="factura.rj_id" class="text-success" title="Înregistrare existentă">✅</span>
                  <span v-else class="text-danger" title="Fără înregistrare">❌</span>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-light-primary"
                    title="Editează"
                    @click="openLucruModal(factura)"
                  >
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Modal Bootstrap pentru lucru pe factură -->
    <div class="modal fade" id="lucruModalFacturiPrimite" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-xxl-custom modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lucru pe factură</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="hideLucruModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-4">
              <!-- LEFT: Factura details + products -->
              <div class="col-12 col-xl-6">
                <div class="mb-4">
                  <div class="fs-6 text-muted mb-2">Detalii factură</div>
                  <div class="border rounded p-3 bg-light">
                    <div class="row mb-2">
                      <div class="col-5 text-muted">ID</div>
                      <div class="col-7">{{ modalFactura?.id ?? '-' }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-muted">Serie / Nr.</div>
                      <div class="col-7">{{ (modalFactura?.serie_doc || '') + (modalFactura?.nr_doc || '') }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-muted">Data</div>
                      <div class="col-7">{{ formatDate(modalFactura?.data_doc) || '-' }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-muted">Data eFactura</div>
                      <div class="col-7">{{ $filters.formatDate(modalFactura?.afp_data_creare) || '-' }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-muted">Furnizor</div>
                      <div class="col-7">{{ modalFactura?.f_denumire || '-' }}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-muted">Valoare / TVA / Total</div>
                      <div class="col-7">
                        {{ formatMoney(modalFactura?.intrari_date_valoare) }} /
                        {{ formatMoney(modalFactura?.intrari_date_tva) }} /
                        {{ formatMoney(modalFactura?.intrari_date_total) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="d-flex align-items-center mb-2">
                    <div class="fs-6 text-muted me-2">Produse</div>
                    <div v-if="modalLoading" class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>
                  </div>
                  <div class="modal-products-scroll border rounded">
                    <table class="table table-sm table-striped align-middle mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Denumire</th>
                          <th class="text-end">Cant.</th>
                          <th class="text-end">Preț</th>
                          <th class="text-end">Valoare</th>
                          <th class="text-end">TVA</th>
                          <th class="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!modalLoading && (!modalProduse || modalProduse.length === 0)">
                          <td colspan="7" class="text-center text-muted py-4">Nu există produse pentru această factură.</td>
                        </tr>
                        <tr v-for="(p, idx) in modalProduse" :key="`p_${idx}`">
                          <td>{{ idx + 1 }}</td>
                          <td>{{ productName(p) }}</td>
                          <td class="text-end">{{ productQty(p) }}</td>
                          <td class="text-end">{{ productPrice(p) }}</td>
                          <td class="text-end">{{ productValue(p) }}</td>
                          <td class="text-end">{{ productTva(p) }}</td>
                          <td class="text-end">{{ productTotal(p) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- RIGHT: RJ form -->
              <div class="col-12 col-xl-6">
                <div class="d-flex align-items-center mb-2">
                  <div class="fs-6 text-muted me-2">Înregistrare contabilă (RJ)</div>
                  <span v-if="rjExists" class="badge badge-light-success">Înregistrare existentă</span>
                  <span v-else class="badge badge-light-danger">Fără înregistrare</span>
                </div>
                <form @submit.prevent="submitRJ" autocomplete="off">
                  <alert-error :form="rjForm" />

                  <div class="row g-3">
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switchAutoRJ" v-model="useAutoRJ">
                        <label class="form-check-label" for="switchAutoRJ">
                          Postare automată (2 linii: 6xx & 4426 → 401)
                        </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label">Data document</label>
                      <input type="date" class="form-control" v-model="rjForm.doc_data" />
                      <has-error :form="rjForm" field="doc_data" />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label">Observații</label>
                      <input type="text" class="form-control" v-model="rjForm.observatii" placeholder="Notițe interne" />
                      <has-error :form="rjForm" field="observatii" />
                    </div>

                    <div class="col-12">
                      <label class="form-label">Furnizor</label>
                      <input type="text" class="form-control" :value="furnizorLabel" disabled />
                      <input type="hidden" v-model="rjForm.furnizor_id" />
                      <has-error :form="rjForm" field="furnizor_id" />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Monedă</label>
                      <select class="form-select" v-model="rjForm.moneda">
                        <option value="RON">RON</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Curs</label>
                      <input type="number" step="0.0001" class="form-control text-end" v-model.number="rjForm.curs" :readonly="rjForm.moneda==='RON'" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Serie / Nr.</label>
                      <input type="text" class="form-control" :value="`${rjForm.serie_doc}${rjForm.nr_doc}`" readonly />
                    </div>

                    <div class="col-12 col-md-6">
                      <label class="form-label">Cont debit</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          style="max-width: 120px"
                          v-model="rjForm.cont_debit_sint"
                          @input="updateContDebit"
                          placeholder="628"
                        />
                        <span class="input-group-text">.</span>
                        <input
                          type="text"
                          class="form-control"
                          v-model="rjForm.cont_debit_an"
                          @input="updateContDebit"
                          placeholder="Analitic (opțional)"
                        />
                      </div>
                      <small class="text-muted">
                        * Vom adăuga căutare după planul de conturi
                        <span v-if="useAutoRJ">— opțional (override în modul automat; implicit 628)</span>
                      </small>
                      <has-error :form="rjForm" field="cont_debit_id" />
                    </div>
                    <div class="col-12 col-md-6">
                      <label class="form-label">Cont credit
                        <span v-if="useAutoRJ" class="badge bg-light text-muted ms-1">setat automat: 401.ID_furnizor</span>
                        <span v-else class="badge bg-primary ms-1">manual</span>
                      </label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          style="max-width: 120px"
                          v-model="rjForm.cont_credit_sint"
                          @input="updateContCredit"
                          placeholder="401"
                          :disabled="useAutoRJ"
                        />
                        <span class="input-group-text">.</span>
                        <input
                          type="text"
                          class="form-control"
                          v-model="rjForm.cont_credit_an"
                          @input="updateContCredit"
                          :placeholder="modalFactura?.id_furnizor ? String(modalFactura.id_furnizor) : 'ID_furnizor'"
                          :disabled="useAutoRJ"
                        />
                      </div>
                      <small v-if="!useAutoRJ && contCreditSugerat" class="text-muted">Sugestie: {{ contCreditSugerat }}</small>
                      <small v-if="useAutoRJ" class="text-muted d-block">În modul automat, contul de credit se calculează ca 401.{{ modalFactura?.id_furnizor || 'ID_furnizor' }}.</small>
                      <has-error :form="rjForm" field="cont_credit_id" />
                    </div>

                    <div class="col-12 col-md-4">
                      <label class="form-label">Valoare (bază)</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.valoare" @input="syncRJTotal" />
                      <has-error :form="rjForm" field="valoare" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">TVA</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.tva" @input="syncRJTotal" />
                      <has-error :form="rjForm" field="tva" />
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Cont TVA</label>
                      <input type="text" class="form-control" v-model="rjForm.cont_tva_id" placeholder="4426" />
                      <small class="text-muted">
                        Implicit: 4426 (TVA deductibilă)
                        <span v-if="useAutoRJ">— opțional (override în modul automat)</span>
                      </small>
                    </div>
                    <div class="col-12 col-md-4">
                      <label class="form-label">Total</label>
                      <input type="number" step="0.01" class="form-control text-end" v-model="rjForm.total" readonly />
                    </div>
                    <!-- Previzualizare pentru modul AUTO -->
                    <div v-if="useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile (AUTO — previzualizare)</label>
                      <table class="table table-sm table-bordered align-middle mb-1">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th class="text-end">Sumă</th>
                            <th>Explicație</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="autoPreviewLines.length === 0">
                            <td colspan="4" class="text-center text-muted py-3">Completează valorile pentru a vedea previzualizarea.</td>
                          </tr>
                          <tr v-for="(r, i) in autoPreviewLines" :key="`auto_${i}`">
                            <td>{{ r.debit }}</td>
                            <td>{{ r.credit }}</td>
                            <td class="text-end">{{ Number(r.suma).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            <td>{{ r.explicatie }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <small class="text-muted">* Previzualizare informativă — la salvare se vor posta exact aceste linii (debit → credit).</small>
                    </div>
                    <!-- Repeater pentru modul MANUAL -->
                    <div v-if="!useAutoRJ" class="col-12">
                      <label class="form-label fw-bold">Linii contabile</label>
                      <table class="table table-sm table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th style="width:160px" class="text-end">Sumă</th>
                            <th>Explicație</th>
                            <th style="width:48px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(linie, idx) in liniiRJ" :key="`rj_${idx}`">
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.cont_debit"
                                placeholder="ex: 628 sau 401.26"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.cont_credit"
                                placeholder="ex: 401 sau 707.01"
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                step="0.01"
                                class="form-control text-end"
                                v-model.number="linie.suma"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                class="form-control"
                                v-model="linie.explicatie"
                                placeholder="Explicație"
                              />
                            </td>
                            <td class="text-center">
                              <button
                                type="button"
                                class="btn btn-sm btn-light-danger"
                                @click="liniiRJ.splice(idx, 1)"
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button type="button" class="btn btn-light-primary btn-sm"
                              @click="liniiRJ.push({ cont_debit: '', cont_credit: '', suma: 0, explicatie: '' })">
                        <i class="fa-solid fa-plus"></i> Adaugă linie
                      </button>
                      <small class="text-muted ms-2">Sfat: asigură-te că totalul debitelor = totalul creditelor.</small>
                    </div>

                    <div class="col-12 d-flex justify-content-end gap-2">
                      <button type="button" class="btn btn-light" @click="resetRJ">Reset</button>
                      <button type="submit" class="btn btn-primary" :disabled="savingRJ">
                        <span v-if="savingRJ" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Salvează RJ
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="hideLucruModal">Închide</button>
            <button type="button" class="btn btn-primary" @click="saveLucruModal">Salvează (în curând)</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createApp } from 'vue';
import axios from 'axios';
// atenție la cale: componenta e în folderul părinte față de work_components
import IntrariFacturaChild from './Intrari_FacturaChild.vue';


export default {
  name: 'FacturiPrimite',
  // components: { LucruModalFacturiPrimite },
  props: {
    firmaId: { type: [Number, String], required: true }
  },
  data() {
    return {
      facturi: [],
      selectedRowIds: [],
      expandedRows: [],
      produseCache: {},    // { [idFactura]: rows[] }
      childApps: {},       // { [idFactura]: appInstance }
      dtInstance: null,
      dtInitializing: false,
      // modalOpen removed
      modalFactura: null,
      modalProduse: [],
      modalLoading: false,
      rjForm: new Form({
        doc_data: '',
        cont_debit_id: '',
        cont_credit_id: '',
        valoare: '',
        tva: '',
        total: '',
        observatii: '',
        furnizor_id: '',
        cont_credit_sint: '401',
        cont_credit_an: '',
        cont_debit_sint: '628',
        cont_debit_an: '',
        cont_tva_id: '4426',
        id_document: '',
        serie_doc: '',
        nr_doc: '',
        tip_document: 'FACTURA_INTRARE',
        moneda: 'RON',
        curs: 1,
        perioada_contabila: '',
        data_efactura: '',
        data_scadenta: ''
      }),
      // Linii contabile pentru modul MANUAL (repeater)
      liniiRJ: [],
      useAutoRJ: true,
      savingRJ: false,
      rjExists: false,
    };
  },
  computed: {
    selectAllVisibleChecked() {
      if (!Array.isArray(this.facturi) || this.facturi.length === 0) return false;
      const visibleIds = this.facturi.map(r => r.id);
      return visibleIds.every(id => this.selectedRowIds.includes(id));
    },
    furnizorLabel() {
      const f = this.modalFactura || {};
      const id = f?.id_furnizor ?? '';
      const name = f?.f_denumire || '-';
      return id ? `${name} (ID: ${id})` : name;
    },
    contCreditSugerat() {
      const id = this.modalFactura?.id_furnizor;
      return id ? `401.${id}` : '';
    },
    autoPreviewLines() {
      // Previzualizare read-only pentru modul AUTO: 6xx → 401 și 4426 → 401
      const v = Number(this.rjForm?.valoare || 0);
      const t = Number(this.rjForm?.tva || 0);
      const credit = this.modalFactura?.id_furnizor ? `401.${this.modalFactura.id_furnizor}` : '401';
      const debit6xx = this.rjForm?.cont_debit_id || '628';
      const contTva = this.rjForm?.cont_tva_id || '4426';
      const rows = [];
      if (v > 0) rows.push({ debit: debit6xx, credit, suma: v, explicatie: 'Cheltuială (bază)' });
      if (t > 0) rows.push({ debit: contTva, credit, suma: t, explicatie: 'TVA deductibilă' });
      return rows;
    },
  },
  watch: {
    firmaId: {
      immediate: true,
      handler() {
        this.loadFacturi();
      }
    }
  },
  mounted() {},
  beforeUnmount() {
    try { window.$('#lucruModalFacturiPrimite').modal('hide'); } catch {}
    this.destroyDT();
    Object.values(this.childApps).forEach(app => { try { app.unmount(); } catch {} });
    this.childApps = {};
  },
  methods: {
    // ===== Helpers =====
    ensureDTReady(cb, attempt = 0) {
      const MAX = 10;
      const $ = window.jQuery || window.$;
      const ready = ($ && $.fn && ($.fn.DataTable || $.fn.dataTable)) || (typeof window !== 'undefined' && window.DataTable);
      if (ready) { cb($); return; }
      if (attempt >= MAX) { console.warn('DataTables not available after wait'); return; }
      setTimeout(() => this.ensureDTReady(cb, attempt + 1), 50);
    },
    destroyDT() {
      if (this.dtInstance && typeof this.dtInstance.destroy === 'function') {
        try { this.dtInstance.destroy(); } catch {}
      }
      this.dtInstance = null;
    },
    formatDate(d) {
      if (!d) return '';
      try { return new Date(d).toLocaleDateString('ro-RO'); } catch { return ''; }
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    },
    statusBadge(stare) {
      const s = String(stare || '').toLowerCase();
      if (['platita','plătită','achitata','achitată','paid'].includes(s)) return 'badge badge-light-success';
      if (['neplatita','neplătită','unpaid','restanta','restanță'].includes(s)) return 'badge badge-light-danger';
      return 'badge badge-light';
    },
    isSelected(id) {
      return this.selectedRowIds.includes(id);
    },
    onToggleSelect(id, ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const idx = this.selectedRowIds.indexOf(id);
      if (checked && idx === -1) this.selectedRowIds.push(id);
      if (!checked && idx !== -1) this.selectedRowIds.splice(idx, 1);
    },
    onToggleSelectAllVisible(ev) {
      const checked = !!(ev && ev.target && ev.target.checked);
      const visibleIds = (this.facturi || []).map(r => r.id);
      if (checked) {
        this.selectedRowIds = Array.from(new Set([...this.selectedRowIds, ...visibleIds]));
      } else {
        this.selectedRowIds = this.selectedRowIds.filter(id => !visibleIds.includes(id));
      }
    },

    // ===== Data loading =====
    async loadFacturi() {
      if (!this.firmaId) return;
      try {
        const res = await axios.get('/api/administrare/work/incarcaFacturiPrimite', { params: { firma_id: this.firmaId } });
        this.facturi = Array.isArray(res.data) ? res.data : (res.data.facturi || []);

        $(document).ready(() => {
          const $tbl = $('#tabel_facturi_primite');
          // Destroy if already initialised
          try {
            if ($.fn.DataTable && $.fn.DataTable.isDataTable && $.fn.DataTable.isDataTable($tbl)) {
              $tbl.DataTable().destroy();
            }
          } catch {}

          // date-eu sorter
          $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
            if (!date) return 0;
            const parts = date.split('.');
            return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`);
          };

          const vm = this;
          $tbl.DataTable({
            pageLength: 15,
            lengthChange: false,
            columnDefs: [
              { targets: 0, responsivePriority: 1 },
              { targets: 2, type: 'date-eu' }
            ],
            order: [[2, 'desc']],
            buttons: ['disable'],
            language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
            paging: true,
            ordering: true,
            info: true,
            searching: true,
            responsive: false,
            //scrollX: true,
            createdRow: function (row, data, dataIndex) {
              const factura = vm.facturi[dataIndex];
              if (factura && factura.id) {
                $(row).addClass(`row-fp-${factura.id}`);
              }
            }
          });
        });
      } catch (e) {
        console.error('Eroare la încărcarea facturilor primite:', e);
        this.facturi = [];
        $(document).ready(() => {
          try { $('#tabel_facturi_primite').DataTable().destroy(); } catch {}
          $('#tabel_facturi_primite').DataTable({ responsive: false });
        });
      }
    },

    initDT() {
      // no-op: initializarea DataTable se face direct in loadFacturi(), similar cu ListaFacturi.vue
    },

    // ===== Child row =====
    async incarcaProduseFactura(id) {
      try {
        const response = await axios.get(`/api/administrare/work/incarcaFacturiPrimite/${id}`);
        const data = Array.isArray(response.data)
          ? response.data
          : (response.data?.produse || response.data?.items || response.data?.rows || []);
        this.produseCache = { ...this.produseCache, [id]: data };
        return data;
      } catch (error) {
        console.error(`Eroare la încărcarea produselor pentru factura primită ${id}:`, error);
        this.produseCache = { ...this.produseCache, [id]: [] };
        return [];
      }
    },

    toggleFacturaDetails(factura) {
      const $ = window.jQuery || window.$;
      const table = $ && $.fn && $.fn.DataTable ? $('#tabel_facturi_primite').DataTable() : null;
      if (!table) return;

      const tr = $(`.row-fp-${factura.id}`);
      const row = table.row(tr);

      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass('shown');
        this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
        const inst = this.childApps[factura.id];
        if (inst && typeof inst.unmount === 'function') {
          try { inst.unmount(); } catch {}
        }
        delete this.childApps[factura.id];
        return;
      }

      const mountChild = (items) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'dt-row-child';
        const app = createApp(IntrariFacturaChild, { factura, produse: items || [] });
        app.mount(wrapper);
        this.childApps[factura.id] = app;
        row.child(wrapper).show();
        tr.addClass('shown');
        if (!this.expandedRows.includes(factura.id)) this.expandedRows.push(factura.id);
      };

      row.child('<div class="p-3 text-muted">Se încarcă produsele...</div>').show();
      tr.addClass('shown');

      if (this.produseCache[factura.id]) {
        mountChild(this.produseCache[factura.id]);
      } else {
        this.incarcaProduseFactura(factura.id).then(() => {
          const items = this.produseCache[factura.id] || [];
          mountChild(items);
        });
      }
    },
    async openLucruModal(factura) {
      this.modalFactura = factura || null;
      this.modalLoading = true;
      this.modalProduse = [];
      this.liniiRJ = [];
      this.rjExists = false;

      try {
        const id = factura?.id;

        // 1) Încărcăm produsele facturii (ca înainte)
        try {
          if (id) {
            if (this.produseCache[id]) {
              this.modalProduse = this.produseCache[id];
            } else {
              const items = await this.incarcaProduseFactura(id);
              this.modalProduse = items || [];
            }
          }
        } catch (e) {
          console.error('Eroare la încărcarea produselor pentru modal:', e);
          this.modalProduse = [];
        }

        // 2) Încercăm să încărcăm înregistrarea din Registru Jurnal, dacă există
        if (id && this.firmaId) {
          try {
            const resp = await axios.get('/api/administrare/work/reg-jurnal/factura-primita', {
              params: {
                firma_id: this.firmaId,
                document_id: id,
                tip_document: 'FACTURA_INTRARE'
              }
            });

            if (resp.data && resp.data.exists) {
              this.rjExists = true;
              const a = resp.data.antet || {};
              const docDateRaw = a.doc_data || factura.data_doc || null;
              const docDate = docDateRaw ? new Date(docDateRaw) : new Date();

              // Antet RJ din baza de date
              this.rjForm.doc_data = docDate.toISOString().slice(0, 10);
              this.rjForm.observatii = a.observatii || '';
              this.rjForm.furnizor_id = a.id_furnizor || factura.id_furnizor || '';
              this.rjForm.moneda = a.moneda || 'RON';
              this.rjForm.curs = a.curs || 1;
              this.rjForm.serie_doc = a.doc_serie || factura.serie_doc || '';
              this.rjForm.nr_doc = a.doc_numar || factura.nr_doc || '';
              this.rjForm.tip_document = a.tip_document || 'FACTURA_INTRARE';
              this.rjForm.id_document = a.id_document || factura.id || '';
              this.rjForm.perioada_contabila =
                a.perioada_contabila ||
                `${docDate.getFullYear()}-${String(docDate.getMonth() + 1).padStart(2, '0')}`;
              this.rjForm.data_efactura = a.data_efactura || factura.afp_data_creare || '';
              this.rjForm.data_scadenta = a.data_scadenta || factura.data_scadenta || '';

              const baza = a.valoare_baza != null
                ? Number(a.valoare_baza)
                : Number(factura.intrari_date_valoare || 0);
              const tva = a.valoare_tva != null
                ? Number(a.valoare_tva)
                : Number(factura.intrari_date_tva || 0);
              const total = a.valoare_total != null
                ? Number(a.valoare_total)
                : Number(factura.intrari_date_total || (baza + tva));

              this.rjForm.valoare = baza ? baza.toFixed(2) : '';
              this.rjForm.tva = tva ? tva.toFixed(2) : '';
              this.rjForm.total = total ? total.toFixed(2) : '';
              this.rjForm.cont_tva_id = this.rjForm.cont_tva_id || '4426';

              // Liniile RJ existente (modul MANUAL) — 1:1 cu structura din DB (debit/credit)
              this.liniiRJ = (resp.data.linii || []).map(l => ({
                cont_debit: l.cont_debit || '',
                cont_credit: l.cont_credit || '',
                suma: Number(l.suma || 0),
                explicatie: l.explicatie || ''
              }));

              // Dacă avem linii în RJ -> comutăm automat pe modul MANUAL
              this.useAutoRJ = this.liniiRJ.length === 0;

              // Dacă, din orice motiv, nu există linii, facem prefill standard (AUTO)
              if (this.useAutoRJ) {
                this.prefillRJForm();
              }
            } else {
              // Nu există RJ pentru această factură -> prefill ca înainte (AUTO)
              this.rjExists = false;
              this.useAutoRJ = true;
              this.prefillRJForm();
            }
          } catch (err) {
            console.error('Eroare la încărcarea RJ pentru factură:', err);
            this.rjExists = false;
            this.useAutoRJ = true;
            this.prefillRJForm();
          }
        } else {
          // Nu avem id factură sau firmă validă -> fallback la prefill
          this.useAutoRJ = true;
          this.prefillRJForm();
        }
      } finally {
        this.modalLoading = false;
        try {
          window.$('#lucruModalFacturiPrimite').modal('show');
        } catch (e) {
          const modalEl = document.getElementById('lucruModalFacturiPrimite');
          if (window.bootstrap && modalEl) {
            const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
            modal.show();
          }
        }
      }
    },
    productName(p) {
      return (p?.denumire || p?.nume || p?.name || p?.description || p?.descriere || '-');
    },
    productQty(p) {
      const q = Number(p?.cantitate ?? p?.qty ?? p?.quantity ?? 0);
      return q ? q.toLocaleString('ro-RO', { maximumFractionDigits: 4 }) : '0';
    },
    productPrice(p) {
      const v = Number(p?.pret ?? p?.price ?? 0);
      return this.formatMoney(v);
    },
    productValue(p) {
      const v = Number(p?.valoare ?? p?.value ?? p?.line_value ?? 0);
      return this.formatMoney(v);
    },
    productTva(p) {
      const v = Number(p?.tva ?? p?.vat ?? 0);
      return this.formatMoney(v);
    },
    productTotal(p) {
      const v = Number(p?.total ?? (Number(p?.valoare ?? 0) + Number(p?.tva ?? 0)));
      return this.formatMoney(v);
    },

    hideLucruModal() {
      try { window.$('#lucruModalFacturiPrimite').modal('hide'); } catch(e) {
        const modalEl = document.getElementById('lucruModalFacturiPrimite');
        if (window.bootstrap && modalEl) {
          const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
          modal.hide();
        }
      }
    },

    saveLucruModal() {
      this.hideLucruModal();
    },
    prefillRJForm() {
      const f = this.modalFactura || {};
      const value = Number(f?.intrari_date_valoare || 0);
      const tva = Number(f?.intrari_date_tva || 0);
      const total = Number(f?.intrari_date_total || (value + tva));
      this.rjForm.doc_data = (f?.data_doc ? new Date(f.data_doc).toISOString().slice(0,10) : new Date().toISOString().slice(0,10));
      this.rjForm.cont_debit_sint = '628';
      this.rjForm.cont_debit_an = '';
      this.updateContDebit();
      this.rjForm.cont_credit_sint = '401';
      this.rjForm.cont_credit_an = (f?.id_furnizor ? String(f.id_furnizor) : '');
      this.updateContCredit();
      this.rjForm.valoare = value ? value.toFixed(2) : '';
      this.rjForm.tva = tva ? tva.toFixed(2) : '';
      this.rjForm.total = total ? total.toFixed(2) : '';
      this.rjForm.observatii = '';
      this.rjForm.furnizor_id = f?.id_furnizor || '';   // ✅ nou
      this.rjForm.cont_tva_id = '4426';
      // Antet RJ
      this.rjForm.id_document = f?.id || '';
      this.rjForm.serie_doc = f?.serie_doc || '';
      this.rjForm.nr_doc = f?.nr_doc || '';
      this.rjForm.tip_document = 'FACTURA_INTRARE';
      this.rjForm.moneda = 'RON';
      this.rjForm.curs = 1;
      const d = (f?.data_doc ? new Date(f.data_doc) : new Date());
      this.rjForm.perioada_contabila = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
      this.rjForm.data_efactura = f?.afp_data_creare || '';
      this.rjForm.data_scadenta = f?.data_scadenta || '';
      // Prefill linii pentru modul MANUAL (linii complete Debit/Credit)
      const _v = Number(this.rjForm.valoare || 0);
      const _t = Number(this.rjForm.tva || 0);
      const credit401 = this.modalFactura?.id_furnizor
        ? `401.${this.modalFactura.id_furnizor}`
        : (this.rjForm.cont_credit_id || '401');
      const debit6xx = this.rjForm.cont_debit_id || '628';
      const contTva = this.rjForm.cont_tva_id || '4426';

      this.liniiRJ = [];
      if (_v > 0) {
        this.liniiRJ.push({
          cont_debit: debit6xx,
          cont_credit: credit401,
          suma: _v,
          explicatie: 'Cheltuială (bază)'
        });
      }
      if (_t > 0) {
        this.liniiRJ.push({
          cont_debit: contTva,
          cont_credit: credit401,
          suma: _t,
          explicatie: 'TVA deductibilă'
        });
      }
    },
    updateContCredit() {
      const s = (this.rjForm.cont_credit_sint || '').toString().trim();
      const a = (this.rjForm.cont_credit_an || '').toString().trim();
      this.rjForm.cont_credit_id = s && a ? `${s}.${a}` : (s || a || '');
    },
    updateContDebit() {
      const s = (this.rjForm.cont_debit_sint || '').toString().trim();
      const a = (this.rjForm.cont_debit_an || '').toString().trim();
      this.rjForm.cont_debit_id = s && a ? `${s}.${a}` : (s || a || '');
    },
    syncRJTotal() {
      const v = parseFloat(this.rjForm.valoare || 0) || 0;
      const t = parseFloat(this.rjForm.tva || 0) || 0;
      this.rjForm.total = (v + t).toFixed(2);
    },
    resetRJ() {
      this.prefillRJForm();
    },
    async submitRJ() {
      try {
        this.savingRJ = true;

        const errs = [];
        const v = parseFloat(this.rjForm.valoare || 0) || 0;
        const t = parseFloat(this.rjForm.tva || 0) || 0;
        const tot = parseFloat(this.rjForm.total || 0) || 0;

        // Validări comune
        if (!this.rjForm.doc_data) errs.push('Data document este obligatorie.');
        if (!this.rjForm.furnizor_id) errs.push('Furnizorul nu este setat.');
        if (this.rjForm.moneda !== 'RON' && (!this.rjForm.curs || this.rjForm.curs <= 0)) errs.push('Cursul valutar trebuie setat pentru monedă ≠ RON.');
        // Limităm validarea v+t=tot doar la AUTO
        if (this.useAutoRJ && +(v + t).toFixed(2) !== +tot.toFixed(2)) errs.push(`Balanța nu este egală (Debit ${(v+t).toFixed(2)} ≠ Credit ${tot.toFixed(2)}).`);

        // Validări specifice modului MANUAL
        if (!this.useAutoRJ) {
          // Validări pentru repeater (MANUAL)
          if (!Array.isArray(this.liniiRJ) || this.liniiRJ.length === 0) {
            errs.push('Adaugă cel puțin o linie contabilă.');
          } else {
            const invalid = this.liniiRJ.find(l =>
              !l ||
              !(Number(l.suma) > 0) ||
              (!l.cont_debit && !l.cont_credit)
            );
            if (invalid) {
              errs.push('Toate liniile trebuie să aibă cel puțin un cont (debit sau credit) și o sumă > 0.');
            }
            const sumD = this.liniiRJ.reduce((a, l) => a + ((l.cont_debit ? Number(l.suma) || 0 : 0)), 0);
            const sumC = this.liniiRJ.reduce((a, l) => a + ((l.cont_credit ? Number(l.suma) || 0 : 0)), 0);
            if (+sumD.toFixed(2) !== +sumC.toFixed(2)) {
              errs.push(`Balanța liniilor nu este egală (D ${sumD.toFixed(2)} ≠ C ${sumC.toFixed(2)}).`);
            }
          }
        }

        if (errs.length) {
          Swal.fire({ icon: 'error', title: 'Eroare!', html: `<ul class="text-start mb-0">${errs.map(e=>`<li>${e}</li>`).join('')}</ul>` });
          return;
        }

        // Antet comun
        const antet = {
          id_firma: this.firmaId,
          id_document: this.rjForm.id_document,
          tip_document: this.rjForm.tip_document,
          serie_doc: this.rjForm.serie_doc,
          nr_doc: this.rjForm.nr_doc,
          data_doc: this.rjForm.doc_data,
          data_efactura: this.rjForm.data_efactura || null,
          data_scadenta: this.rjForm.data_scadenta || null,
          moneda: this.rjForm.moneda,
          curs: this.rjForm.curs,
          perioada_contabila: this.rjForm.perioada_contabila,
          id_furnizor: this.rjForm.furnizor_id,
          valoare_baza: v,
          valoare_tva: t,
          valoare_total: tot,
          observatii: this.rjForm.observatii || ''
        };

        if (this.useAutoRJ) {
          // AUTO mode: folosim endpointul unificat cu flag-ul auto
          // optional: trimitem override pentru conturile implicite dacă utilizatorul a completat
          const antetAuto = {
            ...antet,
            cont_debit: this.rjForm.cont_debit_id || undefined,
            cont_tva: this.rjForm.cont_tva_id || undefined,
          };
          const { data } = await axios.post('/api/administrare/work/reg-jurnal/save', { auto: true, antet: antetAuto });
          const msg = (data && (data.message || data.msg)) || 'Înregistrarea a fost salvată (automat).';
          Swal.fire({ icon: 'success', title: 'Salvat', text: msg });
          this.hideLucruModal();
        } else {
          // MANUAL mode: recalculăm antetul pe baza liniilor introduse
          // Recalculăm sumele pe baza liniilor introduse
          const sumD = this.liniiRJ.reduce((a, l) => a + ((l.cont_debit ? Number(l.suma) || 0 : 0)), 0);
          const sumC = this.liniiRJ.reduce((a, l) => a + ((l.cont_credit ? Number(l.suma) || 0 : 0)), 0);
          // TVA = suma liniilor unde contul de debit începe cu 4426; Bază = restul debitelor
          const tvaFromLines = this.liniiRJ
            .filter(l => typeof l.cont_debit === 'string' && l.cont_debit.trim().startsWith('4426'))
            .reduce((a, l) => a + (Number(l.suma) || 0), 0);
          const bazaFromLines = sumD - tvaFromLines;
          const totalFromLines = sumD; // = sumC, deja validat mai sus

          // suprascriem antetul cu valorile din linii, pentru a evita neconcordanțele
          const antetManual = {
            ...antet,
            valoare_baza: Number(bazaFromLines.toFixed(2)),
            valoare_tva: Number(tvaFromLines.toFixed(2)),
            valoare_total: Number(totalFromLines.toFixed(2)),
          };

          // Trimitem liniile introduse de utilizator
          const linii = this.liniiRJ
            .filter(l => l && Number(l.suma) > 0 && (l.cont_debit || l.cont_credit))
            .map(l => ({
              cont_debit: l.cont_debit ? String(l.cont_debit).trim() : null,
              cont_credit: l.cont_credit ? String(l.cont_credit).trim() : null,
              suma: Number(l.suma),
              explicatie: l.explicatie ? String(l.explicatie).trim() : ''
            }));

          const { data } = await axios.post('/api/administrare/work/reg-jurnal/save', { antet: antetManual, linii });
          const msg = (data && (data.message || data.msg)) || 'Înregistrarea a fost salvată.';
          Swal.fire({ icon: 'success', title: 'Salvat', text: msg });
          this.hideLucruModal();
        }
      } catch (e) {
        console.error('Eroare salvare RJ', e);
        const errText = e?.response?.data?.error || e?.response?.data?.message || e?.message || 'A apărut o eroare.';
        Swal.fire({ icon: 'error', title: 'Eroare!', text: errText });
      } finally {
        this.savingRJ = false;
      }
    },
  }
};
</script>

<style scoped>
#tabel_facturi_primite { width: 100% !important; }
.dt-row-child .table { margin-bottom: 0; }
.table > tbody > tr.child > td { padding: 0 !important; }
/* keep left table tidy */
.modal-body .table td, .modal-body .table th { vertical-align: middle; }
</style>

<style scoped>
.modal-products-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.modal-products-scroll > table {
  min-width: 900px; /* force horizontal scroll when modal is narrower */
  white-space: nowrap;
}

/* Make the modal even wider than Bootstrap's modal-xl */
#lucruModalFacturiPrimite .modal-dialog.modal-xxl-custom {
  max-width: 95vw;
  width: 95vw;
}
#lucruModalFacturiPrimite .modal-content {
  border-radius: 0.75rem;
}
</style>